import { RefObject } from "react";
import { INormalizedChartDate } from "../types";

export type BarShapeProps = {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  payload?: INormalizedChartDate;
};

export const createBarShapeRenderer = (
  chartContainerRef: RefObject<HTMLDivElement>,
  onTooltipShow: (x: number, y: number, payload: INormalizedChartDate) => void,
  onTooltipHide: () => void
) => {
  return (props: BarShapeProps): React.ReactElement => {
    const { x, y, width, height, payload } = props;

    if (!payload || x == null || y == null) {
      return <g />;
    }

    const handleMouseEnter = (e: React.MouseEvent<SVGRectElement>) => {
      if (payload && chartContainerRef.current) {
        const rect = chartContainerRef.current.getBoundingClientRect();
        const svgRect = e.currentTarget.getBoundingClientRect();
        const tooltipX = svgRect.left - rect.left + (svgRect.width + 2) / 2;
        const tooltipY = svgRect.top - rect.top - 85;
        onTooltipShow(tooltipX, tooltipY, payload);
      }
    };

    const handleMouseLeave = () => {
      onTooltipHide();
    };

    return (
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill="url(#bar-single-gradient)"
        style={{ cursor: 'pointer' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    );
  };
};